import ProviderForm from "components/Provider/form"
import ProviderInForm from "components/ProviderIn/form"
import React, { useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"
import {
  getProviderIps,
  getProviderCommodityClassifications,
  getProviderFundCodes,
  getProviderShipments,
  getProviderItemCategories,
  getProviderItems,
  getProviderProjects,
  getProviderProviders,
  getProviderProvinces,
  getProviderWarehouses,
} from "store/provider-dashboard/provider-dashboard-action"
import { getAllCurrencies } from "store/general-renders/general-action"
import {
  getByIdProviderIn,
  storeProviderIn,
  updateProviderIn,
} from "store/provider-in/provider-in-action"
import { storeProvider } from "store/providers/provider-action"
import { isEmpty, isNaN, isObject } from "lodash"
import { providerInAction } from "store/provider-in/provider-in-slice"
import Preloader from "components/Common/Loader"

const EditProviderIn = () => {
  document.title = "Add Receipts"

  const params = useParams()
  const { id } = params

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { loading, error } = useSelector(state => state.providerIn)

  // Retrieve receipt data from Redux store
  const receipt = useSelector(state => state.providerIn.receipt)

  // Retrieve warehosues data from Redux store
  const warehosues = useSelector(
    state => state.providerDashboard.providerWarehouses
  )

  // Retrieve providers data from Redux store
  const providers = useSelector(
    state => state.providerDashboard.providerProviders
  )

  // Retrieve categories data from Redux store
  const commodityClassifications = useSelector(
    state => state.providerDashboard.ProviderCommodityClassifications
  )
  const categories = useSelector(
    state => state.providerDashboard.ProviderItemCategoires
  )

  // Retrieve items data from Redux store
  const items = useSelector(state => state.providerDashboard.ProviderItems)

  // Retrieve projects data from Redux store
  const projects = useSelector(
    state => state.providerDashboard.providerProjects
  )

  const fundCodes = useSelector(
    state => state.providerDashboard.ProviderFundCodes
  )
  const shipments = useSelector(
    state => state.providerDashboard.ProviderShipments
  )

  // Retrieve ips data from Redux store
  const ips = useSelector(state => state.providerDashboard.ProviderIps)

  // Retrieve currencies data from Redux store
  const currencies = useSelector(state => state.generalRenders.currencies)

  // Store filtered data and dispatch the action using onAdvancedSearchHandler callback function
  const handleSubmit = (values, file) => {
    // use formData to store file with form
    const forms = new FormData()

    if (!isEmpty(file)) {
      forms.append("document", file)
    }
    forms.append("_method", "put")
    forms.append("receipt_number", values.receipt_number)
    forms.append("batch_number", values.batch_number)
    forms.append("date", values.date)
    forms.append("type", values.type)
    forms.append("other_source", values.other_source)
    forms.append("old_document", receipt?.data?.document)
    forms.append("expire_date", values.expire_date)
    forms.append("in_qty_per_ip", values.in_qty_per_ip)
    forms.append("in_qty_per_unfpa", values.in_qty_per_unfpa)
    forms.append(
      "commodity_classification_id",
      isObject(values.commodity_classification_id)
        ? values.commodity_classification_id.value
        : values.commodity_classification_id
    )
    forms.append(
      "item_category_id",
      isObject(values.item_category_id)
        ? values.item_category_id.value
        : values.item_category_id
    )
    forms.append(
      "item_id",
      isObject(values.item_id) ? values.item_id.value : values.item_id
    )
    forms.append(
      "lost_comment",
      isEmpty(values.lost_comment) ? "" : values.lost_comment
    )
    const lost_quantity = isNaN(values.lost_quantity) ? 0 : values.lost_quantity

    forms.append("lost_quantity", lost_quantity)
    forms.append(
      "provider_id",
      isObject(values.provider_id)
        ? values.provider_id.value
        : values.provider_id
    )
    forms.append("total_value", values.total_value)
    forms.append("unit_price_per_ip", values.unit_price_per_ip)
    forms.append("unit_price_per_unfpa", values.unit_price_per_unfpa)
    forms.append("unit_umo_quantity_per_ip", values.unit_umo_quantity_per_ip)
    forms.append(
      "unit_uom_quantity_per_unfpa",
      values.unit_uom_quantity_per_unfpa
    )
    forms.append(
      "warehouse_id",
      isObject(values.warehouse_id)
        ? values.warehouse_id.value
        : values.warehouse_id
    )

    forms.append(
      "project_id",
      isObject(values.project_id) ? values.project_id.value : values.project_id
    )
    forms.append(
      "fund_code_id",
      isObject(values.fund_code_id)
        ? values.fund_code_id.value
        : values.fund_code_id
    )
    forms.append(
      "shipment_id",
      isObject(values.shipment_id)
        ? values.shipment_id.value
        : values.shipment_id
    )
    forms.append("waybill_number", values.waybill_number || "")
    forms.append(
      "currency_id",
      isObject(values.currency_id)
        ? values.currency_id.value
        : values.currency_id
    )

    dispatch(updateProviderIn(id, forms, navigate))
  }

  // fetch provider in by id and other data for select boxes
  useEffect(() => {
    dispatch(getProviderWarehouses())
    dispatch(getProviderCommodityClassifications())
    dispatch(getProviderFundCodes())
    dispatch(getProviderShipments())
    dispatch(getProviderProjects())
    dispatch(getProviderIps())
    dispatch(getAllCurrencies())
    dispatch(getProviderProviders())
    dispatch(getByIdProviderIn(id))

    return () => {
      dispatch(providerInAction.resetState())
    }
  }, [])

  // fetch provider item based item category
  useEffect(() => {
    if (receipt?.data?.commodity_classification_id) {
      dispatch(
        getProviderItemCategories(receipt.data.commodity_classification_id)
      )
    }
    if (receipt?.data?.item_category_id) {
      dispatch(getProviderItems(receipt.data.item_category_id))
    }
  }, [dispatch, receipt])

  return (
    <React.Fragment>
      {/* Provider In ( Receipt  ) Form  */}
      {!isEmpty(receipt) && items?.data.length > 0 ? (
        <ProviderInForm
          onSubmit={handleSubmit}
          loading={loading}
          error={error}
          formMode={"Edit"}
          warehosues={warehosues?.data}
          providers={providers?.data}
          commodityClassifications={commodityClassifications?.data}
          categories={categories?.data || []}
          items={items?.data}
          receipt={receipt?.data}
          projects={projects?.data}
          fundCodes={fundCodes?.data}
          shipments={shipments?.data}
          currencies={currencies}
          ips={ips?.data}
        />
      ) : (
        <Preloader loading={true} />
      )}
    </React.Fragment>
  )
}

export default EditProviderIn
